import type { DensityPreference } from "./types";

/**
 * Paints the density: `html[data-density="compact"]` in styles/tokens.css
 * swaps the type scale and row height; Comfortable is the `:root` default.
 */
export function applyDensity(density: DensityPreference): void {
  if (typeof document === "undefined") return;
  document.documentElement.dataset.density = density;
}
